import Mutations from '../../odata/mutations';

export default { ...new Mutations('prompt'), ...new Mutations('prompts') };
